import { Component, OnInit } from '@angular/core';
import {LoadingBarService} from '@ngx-loading-bar/core';
import {AppService} from 'src/app/core/services/app.service';
import {SwalService} from 'src/app/core/services/swal.service';
import {LocalStorageService} from 'ngx-webstorage';
import {DetailsObjectif} from 'src/app/core/model/etat-eia';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-etat-eia',
  templateUrl: './etat-eia.component.html',
  styleUrls: ['./etat-eia.component.css']
})
export class EtatEiaComponent implements OnInit {
    selectedDirection: any;
    selectedStructure: any;
    settingsDirection = {};
    settingsStructure = {};
    listDirection: any = [];
    listStructure: any = [];
    response: any;
    vueListEtatEia: boolean = true;
    id_direction: any;
    code_direction: any;
    id_structure: any;
    code_structure: any;
    detailsObjectifCadre: any;
    detailsObjectifAM: any;
    detailsObjectifOE: any;
    detailsObjectifTauxMoyen: any;
    detailsObjectifAppreciation: any;
    detailsTenuePosteCadre: any;
    detailsTenuePosteAM: any;
    detailsTenuePosteOE: any;
    detailsMobiliteCadre: any;
    detailsMobiliteAm: any;
    detailsMobiliteOe: any;
    listDetailsTenueDePosteMaitrisePoste: any;
    listDetailsTenueDePosteQsse: any;
    listDetailsTenueDePosteManagement: any;
    listDetailsTenueDePosteCommunication: any;
    listDetailsTenueDePosteValeur: any;
    totalObjectifs: any;
    totalTenuePoste: any;
    totalMobilite: any;
    constructor(
      private _service: AppService,
      private _loader: LoadingBarService,
      private _swal: SwalService,
      private toastrService: ToastrService,
      private storage: LocalStorageService
  ) { }

    ngOnInit() {
      this.getAllDirection();
      this.settingsDirection = {
          singleSelection: true,
          text: 'Selectionner la direction',
          classes: 'myclass custom-class',
          labelKey: 'code',
          enableSearchFilter: true,
          searchBy: ['code'],
          searchPlaceholderText: 'Rechercher',
          noDataLabel: 'Aucune direction disponible'
      };

      this.settingsStructure = {
          singleSelection: true,
          text: 'Selectionner la structure',
          classes: 'myclass custom-class',
          labelKey: 'code',
          enableSearchFilter: true,
          searchBy: ['code'],
          searchPlaceholderText: 'Rechercher',
          noDataLabel: 'Aucune structure disponible'
      };
  }

    getAllDirection() {
        this._loader.start();
        this._service.getData('capital-humain/structures/direction')
            .subscribe(
                res => {
                    if (res.error === false) {
                        this._loader.stop();
                        this.listDirection = res.data;
                    } else {
                        this._loader.stop();
                        this._swal.error(res.message);
                    }
                }, err => {
                    this._loader.stop();
                    this.toastrService.error(err.error.message);
                }
            );
    }

    onSelectDirection(item) {
        this.id_direction = item.id;
        this.code_direction = item.code;
        this.getAllStructure(item.id);
    }

    onSelectStructure(item) {
        this.id_structure = item.id;
        this.code_structure = item.code;
    }

    onDeSelectItem(item, type) {
        if (type === 'direction') {
            this.id_direction = '';
            this.code_direction = '';
        } else {
            this.id_structure = '';
            this.code_structure = '';
        }
    }

    rechercher() {
        this._loader.start();
        const obj = {
            campagne_id: this.storage.retrieve('idCampagneEiaSelected'),
            code_direction: this.code_direction,
            code_structure: this.code_structure,
        };
        this._service.postData('reporting/etat_eia', obj)
            .subscribe(
                res => {
                    if (res.error === false) {
                        this._loader.stop();
                        this.vueListEtatEia = false;
                        this.detailsObjectifTauxMoyen = res.data.objectif.taux_moyen;
                        this.detailsObjectifAppreciation = res.data.objectif.appreciation;
                        this.detailsObjectifCadre = res.data.objectif.cadre;
                        this.detailsObjectifAM = res.data.objectif.am;
                        this.detailsObjectifOE = res.data.objectif.oe;
                        this.totalObjectifs = res.data.objectif.total;
                        this.detailsTenuePosteCadre = res.data.tenue_de_poste.cadre;
                        this.detailsTenuePosteAM = res.data.tenue_de_poste.am;
                        this.detailsTenuePosteOE = res.data.tenue_de_poste.oe;
                        this.totalTenuePoste = res.data.tenue_poste.total;
                        this.detailsMobiliteCadre = res.data.mobilite.cadre;
                        this.detailsMobiliteAm = res.data.mobilite.am;
                        this.detailsMobiliteOe = res.data.mobilite.oe;
                        this.totalMobilite = res.data.mobilite.total;
                        this.listDetailsTenueDePosteMaitrisePoste = res.data.details_tenue_poste.maitrise_poste;
                    } else {
                        this._loader.stop();
                        this._swal.error(res.message);
                    }
                }, err => {
                    this._loader.stop();
                    this.toastrService.error(err.error.message);
                }
            );
    }

    // Get all structure
    getAllStructure(idDirection) {
        this._loader.start();
        this._service.getData('capital-humain/structures/' + idDirection + '/structure-of-direction').subscribe((data: {}) => {
            this._loader.stop();
            this.response = data;
            this.listStructure = this.response.data;
        });
    }

    printTableauTenuePoste() {
        this._loader.start();
        var data = document.getElementById('tableauTenuePoste');
        html2canvas(data).then(canvas => {
            // Few necessary setting options
            const contentDataURL = canvas.toDataURL('image/png')
            let pdf = new jspdf('landscape', 'mm', 'a4'); // A4 size page of PDF
            pdf.setFontSize(10);
            var position = 20;
            // Few necessary setting options
            var imgWidth = 208;
            var pageHeight = 295;
            var imgHeight = canvas.height * imgWidth / canvas.width;
            var heightLeft = imgHeight;
            pdf.addImage(contentDataURL, 'PNG', 40, position, imgWidth, imgHeight)
            pdf.save(`Tenue_de_Poste_${this.code_direction}.pdf`); // Generated PDF
        });
        this._loader.stop();
    }

}
